import { render, staticRenderFns } from "./MyCourseAttachment.vue?vue&type=template&id=18415aec"
import script from "./MyCourseAttachment.vue?vue&type=script&lang=ts"
export * from "./MyCourseAttachment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports